import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

/* Object Json */
import { safeGetWithType, parse, stringify, clean, safeGet, stringifyFormatted } from 'iotera-base/json';
import { isEmpty, isNone } from 'iotera-base/object';

import { IoteraForm } from '../../lib/components/form';
import { SubViewHeader } from '../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { AreaInput, TextInput } from '../../lib/components/textInput';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const ADD = "ADD";
const WKEY = "RULE_ADD";
const wBoundActions = buildWBoundActions(WKEY);

function schema() {
  return {
    "definitions": {
      "Category": {
        "title": "Category",
        "type": "number",
        "anyOf": [
          {
            type: 'number',
            enum: [
              11
            ],
            title: 'Incoming Device Data'
          },
          {
            type: 'number',
            enum: [
              12
            ],
            title: 'Incoming Device Multiple Data'
          },
          {
            type: 'number',
            enum: [
              21
            ],
            title: 'Device Status V0'
          },
          {
            type: 'number',
            enum: [
              22
            ],
            title: 'Device Status *NEW*'
          },
          {
            type: 'number',
            enum: [
              31
            ],
            title: 'Incoming Device State'
          },
          {
            type: 'number',
            enum: [
              32
            ],
            title: 'State Deleted'
          },
          {
            type: 'number',
            enum: [
              111
            ],
            title: 'Device Created'
          },
          {
            type: 'number',
            enum: [
              112
            ],
            title: 'Device Info Updated'
          },
          {
            type: 'number',
            enum: [
              113
            ],
            title: 'Device Sensors Updated'
          },
          {
            type: 'number',
            enum: [
              119
            ],
            title: 'Device Deleted'
          },
          {
            type: 'number',
            enum: [
              501
            ],
            title: 'Subscription Notification'
          },
          {
            type: 'number',
            enum: [
              931
            ],
            title: 'Device State Records Auto Activation'
          },
          {
            type: 'number',
            enum: [
              10009
            ],
            title: 'Iotera Tap Node Expired'
          }
        ]
      }
    },
    type: "object",
    required: ["name", "category", "condition", "action", "details"],
    properties: {
      name: { type: "string", title: "Nama", maxLength: 30 },
      key: { type: "string", title: "Key", maxLength: 30 },
      description: { type: "string", title: "Deskripsi", maxLength: 128, default: '' },
      category: {
        "$ref": "#/definitions/Category",
        "title": "Category"
      },
      condition: { type: "string", title: "Kondisi" },
      action: { type: "string", title: "Aksi" },
      details: { type: "string", title: "Details" },
    }
  }
};

const uiSchema = {
  name: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="name"
          type="text"
          label="Nama"
          placeholder="Nama"
          textTooltip="Masukkan nama untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  key: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="name"
          type="text"
          label="Key"
          placeholder="Key"
          textTooltip="Masukkan key rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  description: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="description"
          type="text"
          label="Deskripsi"
          placeholder="Deskripsi"
          textTooltip="Masukkan deskripsi untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  condition: {
    "ui:widget": (props) => {
      return (
        <AreaInput
          id="condition"
          type="text"
          label="Kondisi"
          textTooltip="Kondisi yang akan men-trigger rule ini untuk melakukan aksi"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={200}
          {...props}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  action: {
    "ui:widget": (props) => {
      return (
        <AreaInput
          id="action"
          type="text"
          label="Aksi"
          textTooltip="Aksi yang terjadi bila kondisi rule terpenuhi/sesuai"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={200}
          {...props}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  details: {
    "ui:widget": (props) => {
      return (
        <AreaInput
          id="details"
          type="text"
          label="Details"
          textTooltip="Details"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={100}
          {...props}
        />
      )
    },
    "ui:options": {
      label: false
    }
  }
};

class RuleAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      formData: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/rule/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ loading: false })
                  // Magic to refresh routes
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_rule_list_')
                  _props.showSingleNotification({ message: 'Tambah rule sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({ loading: false })
              _props.showSingleNotification({ message: 'Tambah rule gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  handleChange(event) {
    this.setState({ formData: event.formData })
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let submitData = safeGet(_state, ['formData'])
    const name = safeGetWithType(submitData, ['name'], '');
    const key = safeGetWithType(submitData, ['key'], '');
    const description = safeGetWithType(submitData, ['description'], '');
    let category = safeGetWithType(submitData, ['category'], 11);
    let condition = safeGetWithType(submitData, ['condition'], '');
    let action = safeGetWithType(submitData, ['action'], '');
    let details = safeGetWithType(submitData, ['details'], '');
    let condition_object = parse(condition)
    let action_object = parse(action)
    let details_object = parse(details)
    if (isNone(condition_object)) {
      _props.showSingleNotification({ message: 'Kondisi harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: submitData })
      return;
    }
    if (isNone(action_object)) {
      _props.showSingleNotification({ message: 'Aksi harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: submitData })
      return;
    }
    if (isNone(details_object)) {
      _props.showSingleNotification({ message: 'Details harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: submitData })
      return;
    }
    submitData['condition'] = stringifyFormatted(condition_object)
    submitData['action'] = stringifyFormatted(action_object)
    submitData['details'] = stringifyFormatted(details_object)
    _this.setState({ formData: submitData })
    let ruleBody = {
      name,
      category,
      condition: condition_object,
      action: action_object,
      details: details_object,
      description
    }
    if (/^[a-z0-9_]+$/.test(key)) {
      ruleBody['key'] = key;
    }
    clean(ruleBody);
    _this.setState({ loading: true });
    _props.wSingleRequestCall({
      id: ADD,
      body: ruleBody
    });
  }

  render() {
    const _this = this;
    const _state = _this.state
    const { loading, formData } = _state;
    let dataToShow = {}
    if (!isEmpty(formData)) {
      dataToShow = formData
    }
    else {
      dataToShow = {
        "condition": "{}",
        "action": "{}",
        "details": "{}"
      }
      _this.setState({ formData: dataToShow })
    }
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tambah Rule' subTitle='Formulir Tambah Rule' />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema()}
              uiSchema={uiSchema}
              onChange={_this.handleChange}
              formData={dataToShow}
              onSubmit={_this.handleSubmit}
            >
              <div className="button-right">
                <Button variant="outlined" type="button" size="large" style={{ minWidth: '0%' }}
                  onClick={(e) => _this.goTo('.' + S + '_rule_list_')} >Batal</Button>
                <Button variant="contained" size="large" color="primary" type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(null, mapDispatchToProps)(withRouter(RuleAdd));